import React from 'react'
import './style.css'
import { Card, Col } from 'reactstrap'
import { faComments, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Avatar from '../../../../assets/img/default_avatar.png'
import CustomizedButton from './CustomizedButton'
import { useDispatch } from 'react-redux'
import { deleteThread } from 'store/Discussion/actions'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const Discussions = ({ access, list, len, onSearchReset, ...props }) => {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const user = useSelector((state) => state.users.user)

  const dispatch = useDispatch()
  return (
    <div className='d-flex justify-content-center mt--5'>
      <Col xl='10' className='mb-3 '>
        {user.access !== 3 && user.access !== 2 && (
          <Card className='py-2 px-4'>
            <div className='d-flex align-items-center justify-content-between'>
              <h4 className='p-0 m-0'>Add a new thread</h4>
              <Link
                to={`/discussions/create`}
                className='btn btn-info btn-icon btn-2'
                color='info'
                type='button'
              >
                <span className='btn-inner--icon'>
                  <FontAwesomeIcon icon={faPlus} />
                </span>
              </Link>
            </div>
          </Card>
        )}
        {list.map((item, index) => (
          <Card className='py-3 px-4' key={index}>
            <div className='py-2'>
              <h2 className='cursor-pointer'>
                <Link
                  className='p-0 m-0'
                  to={`/discussions/${item.id}/comments`}
                >
                  {item.title}
                </Link>
              </h2>
            </div>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='d-flex py-3'>
                <Link
                  className='custom-avatar mr-2'
                  to={`/discussions/${item.id}/comments`}
                >
                  <img alt='...' src={item.avatar || Avatar} />
                </Link>
                <div>
                  <h4>
                    {item.content.user.first_name} {item.content.user.last_name}
                  </h4>
                  <p className='p-0 m-0' style={{ fontSize: '14px' }}>
                    {item.time}
                  </p>
                </div>
              </div>
              <CustomizedButton
                style={{ borderRadius: '20rem' }}
                cn='btn-lightBlue-bg pointer-disabled'
                children={'KIWI LMS'}
              />
            </div>
            <div className='pb-4'>
              {typeof item.content.data === 'string'
                ? item.content.data
                : item.content?.data?.blocks[0]?.text}
            </div>
            <div className='d-flex align-items-center'>
              {access === 1 || access === 4 || access === 5 ? (
                <CustomizedButton
                  size={'md'}
                  color={''}
                  onClick={() => dispatch(deleteThread(index))}
                  href={'#pablo'}
                  cn={'active btn-lightGrey-bg'}
                  children={<FontAwesomeIcon icon={faTrash} />}
                  style={{ borderRadius: '20rem' }}
                />
              ) : null}
              <Link to={`/discussions/${item.id}/comments`} className='ml-2'>
                <CustomizedButton
                  size={'md'}
                  color={''}
                  cn={'active btn-lightGrey-bg'}
                  children={
                    <span className='d-flex align-items-center m-0 p-0'>
                      <FontAwesomeIcon icon={faComments} />
                      <p className='m-0 p-0'>Add response</p>
                    </span>
                  }
                  style={{ padding: '7px 7px', borderRadius: '20rem' }}
                />
              </Link>
            </div>
          </Card>
        ))}
      </Col>
    </div>
  )
}

export default Discussions
